import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative overflow-hidden bg-cream py-20 md:py-28 px-4" data-id="element-69">
      <div className="max-w-3xl mx-auto text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="space-y-12" data-id="element-71">
          {/* Full brand lockup */}
          <div className="flex justify-center" data-id="element-72">
            <img src="https://cdn.magicpatterns.com/uploads/4sDEekiyXVshgNeog3yRkY/Adobe_Express_-_file.png" alt="Birdie Bag" className="w-32 md:w-40 object-contain" data-id="element-73" />
          </div>

          <p className="text-lg md:text-xl text-charcoal/70 max-w-xl mx-auto leading-relaxed" data-id="element-74">
            A reusable straw set tucked inside a miniature golf bag — designed
            to make sustainable habits feel as natural as your morning round.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-75">
            <a href="#mission" className="px-8 py-4 bg-green text-white font-medium rounded-full hover:bg-green-dark transition-colors text-center tracking-wide" data-id="element-76">
              Discover the Mission
            </a>
            <a href="#product" className="px-8 py-4 bg-transparent text-charcoal border border-charcoal/20 font-medium rounded-full hover:border-charcoal/40 transition-colors text-center tracking-wide" data-id="element-77">
              Meet the Bag
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}